// @flow
import styled from 'styled-components';
import { py, px } from 'styled-components-spacing';

import theme from '@theme';

const { colors } = theme;

const StyledLink = styled.a`
  cursor: pointer;
  ${py(3)}
  ${px(3.5)}
  color: ${props => (props.dropDown ? 'black' : colors.navyGray)};
  ${({ heroSection }) => heroSection && `
     color:white;
  `}

  text-decoration: none;
  font-weight: 500;
  
  transition: all 0.5s ease;
  
  &:hover {
    background-color: ${colors.greyBlue10};
  }
`;

export default StyledLink;
